import React, { useState } from 'react'
import ModalRemoveBatch from '../../../../components/ModalRemoveBatch'
import { removeBatch, removePendingBatch } from '../../ReceivementApi'

const useDeleteBatch = ({ setReadyTable, setNotReadyTable }) => {
    const [deleteBatch, setDeleteBatch] = useState()

    const handleClickBatchRemove = (batch) => {
        setDeleteBatch(batch)
    }

    const handleBatchRemove = async (idBatch, idPendingBatch, badgeUser) => {

        if (idBatch) {
            return removeBatch(idBatch, badgeUser)
                .then(() => {
                    setReadyTable((table) => table.filter(row => row.lot !== idBatch))
                })
                .catch((error) => {
                    throw error
                })
        }
        else if (idPendingBatch) {
            return removePendingBatch(idPendingBatch, badgeUser)
                .then(() => {
                    setNotReadyTable((table) => table.filter(row => row.pendencyId !== idPendingBatch))
                })
                .catch((error) => {
                    throw error
                })
        }
        else {
            throw {
                "message" : "Não foi possível remover o lote do recebimento com os parametros enviados",
                "payload" : deleteBatch
            }
        }
    }

    const removeBatchModalComponent = () => (
        <ModalRemoveBatch
            deleteObject={deleteBatch}
            cancelAction={() => setDeleteBatch()}
            deleteAction={(badgeUser) => handleBatchRemove(deleteBatch?.lot, deleteBatch?.pendencyId, badgeUser)}
        />
    )

    return [handleClickBatchRemove, removeBatchModalComponent]
}

export default useDeleteBatch

